import * as React from "react";

import * as router from "@client/router";
import * as utils from "@client/utils";

import {EntryList} from "@client/components/EntryList";
import {TextInput} from "@client/forms";

export const RecipeList = router.RecipeList.withHooks((props) => {
    const [filter, setFilter] = React.useState("");

    return {
        recipes: props.resolved.recipe_list.filter((recipe) =>
            utils.filterPredicate(recipe.name, filter),
        ),
        filter,
        setFilter,
    };
})
    .withIndex((props) => (
        <EntryList
            createTag={(entry) =>
                entry.user_id != props.profile.user.id ? "shared" : null
            }
            createLink={(entry) =>
                router.reverse("update_recipe.recipe", {recipeId: entry.id})
            }
            entries={props.recipes}
            hiddenMacros={props.profile.has_hidden_macros}
        />
    ))
    .withActions((props) => [
        {
            onClick: () => router.push("create_recipe.index", {}),
            icon: "plus",
            title: "Create",
        },
        {
            link: router.locator({
                route: "create_recipe.import",
                params: {},
                resolved: props.resolved,
            }),
            icon: "0758-download2",
            title: "Import",
        },
    ])
    .withOptions((props) => ({
        title: "Recipes",
        topSection: (
            <TextInput
                name=""
                flush
                readOnly={false}
                placeholder="Filter recipes"
                onChange={props.setFilter}
                value={props.filter}
            />
        ),
    }));
